import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Image from '../image';

const Video = ({ data, className, ...other }) => {
	const [showCover, setShowCover] = useState(data?.image?.[0] ? true : false);

	if (!data?.video_source) return null;

	const onCoverClick = () => setShowCover(false);

	return (
		<div className={`videoComponent ${className || ''}`}>
			<div
				className='relative aspect-video h-full max-w-full'
				{...other}
			>
				{showCover && data.image?.[0] && (
					<button
						aria-label='Watch Video'
						onClick={onCoverClick}
						className='absolute left-0 top-0 z-2 h-full w-full'
					>
						<Image
							data={data.image[0]}
							className='block h-full w-full object-cover'
						/>
					</button>
				)}

				{data.video_id && (
					<iframe
						className='absolute left-0 top-0 h-full w-full border-0'
						title={data.video_title}
						src={data.video_source === 'vimeo' ? `https://player.vimeo.com/video/${data.video_id}` : `https://www.youtube.com/embed/${data.video_id}?rel=0&enablejsapi=1`}
						loading='lazy'
						allowFullScreen
					/>
				)}

				{data.video_source === 'internal' && data.internal_video?.url && (
					// eslint-disable-next-line jsx-a11y/media-has-caption -- TODO: Add track
					<video className='absolute left-0 top-0 h-full w-full border-0'>
						<source
							src={data.internal_video.url}
							type='video/mp4'
						/>
					</video>
				)}
			</div>

			{data.description && (
				<div
					className='mt-4'
					dangerouslySetInnerHTML={{ __html: data.description }}
				/>
			)}
		</div>
	);
};

Video.propTypes = {
	data: PropTypes.object,
	className: PropTypes.string,
};

export default Video;
